import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface TestResultsCardProps {
  onClick: () => void;
}

export default function TestResultsCard({ onClick }: TestResultsCardProps) {
  const { t } = useTranslation();

  const getCardTitleText = () => {
    return (
      t("screening.test_results_card_title_nj") ??
      `Docket now supports certain test results recorded.`
    );
  };

  const getCardBodyText = () => {
    return t("screening.test_results_card_body_nj") ?? "Access your results.";
  };

  return (
    <>
      <div className="flex bg-base-100 mx-4 py-1 mb-2 w-fit text-base-content items-center  rounded-xl">
        <div className="w-12 h-12 shrink-0 mx-2 bg-cover bg-[url(/assets/images/Tests_Generic.png)]">
          {" "}
        </div>
        <div data-testid="lead-disclaimer-card">
          <span>{getCardTitleText()}</span>
          <button onClick={onClick} className="btn btn-link text-primary pl-1 text-base my-0 h-fit">
            {getCardBodyText()}
          </button>
        </div>
      </div>
    </>
  );
}
